// extracted by mini-css-extract-plugin
export default {"discover_page_title":"S1_Discover_discover_page_title__42mDZ","discover_page_line":"S1_Discover_discover_page_line__v66CO"};